/* Contara article header: mobile table-of-contents drawer (CNV-6396) */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktop = window.matchMedia('(min-width: 992px)');

  function headerOffset(header) {
    var section = header.closest('.shopify-section') || header;
    var sticky = getComputedStyle(section).position === 'sticky';
    return sticky ? header.offsetHeight : 0;
  }

  function scrollToHash(header, hash) {
    var target = document.getElementById(decodeURIComponent(hash.slice(1)));
    if (!target) return false;
    var top = target.getBoundingClientRect().top + window.scrollY - headerOffset(header) - 12;
    window.scrollTo({ top: top, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(null, '', hash);
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    return true;
  }

  function init(header) {
    var toggle = header.querySelector('[data-ctr-drawer-toggle]');
    var drawer = header.querySelector('[data-ctr-drawer]');
    var list = header.querySelector('[data-ctr-drawer-list]');
    if (!toggle || !drawer || !list) return;

    var sourceLinks = document.querySelectorAll('nav[data-ctr-article-toc] a[href^="#"]');
    if (!sourceLinks.length) return; // toggle stays hidden

    sourceLinks.forEach(function (link) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = link.getAttribute('href');
      a.textContent = link.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    toggle.hidden = false;

    function setOpen(open, restoreFocus) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      drawer.classList.toggle('is-open', open);
      if (open) {
        drawer.removeAttribute('inert');
        var first = list.querySelector('a');
        if (first) first.focus({ preventScroll: true });
      } else {
        drawer.setAttribute('inert', '');
        if (restoreFocus) toggle.focus();
      }
    }
    function isOpen() { return toggle.getAttribute('aria-expanded') === 'true'; }

    toggle.addEventListener('click', function () { setOpen(!isOpen(), true); });

    list.addEventListener('click', function (event) {
      var a = event.target.closest('a');
      if (!a) return;
      setOpen(false, false);
      if (scrollToHash(header, a.getAttribute('href'))) event.preventDefault();
    });

    document.addEventListener('click', function (event) {
      if (isOpen() && !header.contains(event.target)) setOpen(false, false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen()) setOpen(false, true);
    });
    desktop.addEventListener('change', function (event) {
      if (event.matches && isOpen()) setOpen(false, false);
    });
  }

  function start() {
    document.querySelectorAll('[data-ctr-article-header]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
